import { css } from "@emotion/react";

export const root = css`
  padding: 24px;
  padding-bottom: 6px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const input = css`
  font-size: 12px;
  margin-top: 5px;
`;